import PropTypes from 'prop-types';
import SabreAboutTransformer from '../../../../../lib/sabre-about-transformer/SabreAboutTransformer';

const About = ({ hotelDetails, doShowAgentCommission, headerClassName }) => (
  <SabreAboutTransformer
    hotelDetails={hotelDetails}
    doShowAgentCommission={doShowAgentCommission}
    headerClassName={headerClassName}
  />
);

About.propTypes = {
  hotelDetails: PropTypes.shape().isRequired,
  doShowAgentCommission: PropTypes.bool,
  headerClassName: PropTypes.string,
};

export default About;
